/**
 * Re-export wrapper for backward compatibility
 * This hook wraps useUserRoleLegacy from useUserRoles
 * TODO: Gradually migrate all uses to useUserRoleLegacy directly
 */
import { useUserRoleLegacy } from './useUserRoles';

export const useUserRole = useUserRoleLegacy;
